module.exports = __webpack_public_path__ + "static/media/1.3636d160.png";